// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2Bc6U","balanceDisclaimer":"posDashboard_balanceDisclaimer__2G3eh"};